import React, { useRef, useState, useEffect }               from 'react';
import { Modal, Button, Form }                              from 'react-bootstrap';
import { useDispatch, useSelector }                         from 'react-redux';

import { ICON_SAVE, ICON_CANCEL }                           from '../../extras/icons';
import { saveDefensoriesAction, updateDefensoriesAction }   from '../../../actions/defensoriesActions';
import ButtonSpinner                                        from '../../layout/ButtonSpinner';
import types                                                from '../../../data/defensoryTypes';

import { Formik }                                           from 'formik';
import * as yup                                             from 'yup';

import { listUnitsAction }                                  from '../../../actions/unitsActions';



const DefensoryForm = props => {

    // ========================================================================================================
    // DECLARACIONES ------------------------------------------------------------------------------------------
    // ========================================================================================================

    // Tomo los props
    const { show, handleClose } = props;

    // Genero los refs
    const refDescription = useRef();

    // Datos iniciales
    const initialData = {
        descripcion: '',
        menor: '',
        responsable: '',
        direccion: '',
        email: '',
        telefono: '',
		unidad: ''
    }

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Traigo el store de persona tipos
    const defensoriesLoading = useSelector( state => state.defensories.loadingSave );
    const isEdit = useSelector( state => state.defensories.isEdit );
    const defensorySelected = useSelector( state => state.defensories.defensorySelected );
    const Units = useSelector( state => state.units.units );

    // Inicializo el state local
    const [ defensory, setAudienceCategory ] = useState(initialData);

    // Esquema de validación
    const validationSchema = yup.object({
        descripcion: yup.string().required(),
        menor: yup.number().required(),
        unidad: yup.number().required(),
        responsable: yup.string().nullable(),
        direccion: yup.string().nullable(),
        email: yup.string().email().nullable(),
        telefono: yup.string().nullable()
    });



    // ========================================================================================================
    // FUNCIONES ----------------------------------------------------------------------------------------------
    // ========================================================================================================

    // Modifico según el cambio
    useEffect(() => {
        // Cargo las Unidades en el State        
        dispatch( listUnitsAction() );

        // Me fijo si es edición
        if(isEdit && defensorySelected)
        {   // Cargo los valores para edicion
            setAudienceCategory(defensorySelected);
            // Cambio unidad de un objeto a un numero para que el select muestre el valor precargado
            if(defensorySelected.unidad.id)
            {   let idUnidad = defensorySelected.unidad.id;
                setAudienceCategory({
                    ...defensorySelected,
                    unidad: idUnidad
                });
            }
        }
        else
        {   setAudienceCategory(initialData);
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEdit, defensorySelected, show])

    // Manejo de cambios
    // eslint-disable-next-line
    const handleChange = e => {
        setAudienceCategory({
            ...defensory,
            [e.target.name]: e.target.value
        })
    }

    // Manejo el guardado
    const handleSave = values => {
        //Transformo unidad de un numero a un objeto para devolverlo
        let idUnidad = values.unidad;
        let unidad = Units.find(item => item.id === parseInt(idUnidad) );
        values.unidad = unidad;
        //Inicializo los datos
        let data = {
            ...defensory,
            activo: 1
        }
        //Agrego los nuevos valores
        data = {
            ...data,
            ...values
        }
        //Verifico si es edición o alta
        if(defensory.id){
            //Es edición
            dispatch( updateDefensoriesAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveDefensoriesAction(data, handleCloseForm) );
        }
    }

    // Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refDescription.current.focus();
    }

    // Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setAudienceCategory(initialData);
        //Cierro
        handleClose();
    }
    


    // ========================================================================================================
    // RENDERIZO ----------------------------------------------------------------------------------------------
    // ========================================================================================================
    return (
        <Modal show={show} onHide={handleCloseForm} onShow={handleOnShow} aria-labelledby="contained-modal-title-vcenter" centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    Defensoría&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...defensory }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    values,
                    errors
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-9">
                                    <label htmlFor="descripcion">Descripción</label>
                                    <Form.Control
                                        id="descripcion"
                                        className="form-control" 
                                        autoFocus 
                                        name="descripcion" 
                                        type="text" 
                                        value={ values.descripcion }
                                        onChange={handleChange}
                                        ref={refDescription}
                                        isInvalid={!!errors.descripcion}
                                        disabled={ defensoriesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.descripcion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <label htmlFor="menor">Menores?</label>
                                    <Form.Control
                                        as="select"
                                        id="menor"
                                        className="form-control"  
                                        name="menor" 
                                        type="text" 
                                        value={ values.menor }
                                        onChange={handleChange}
                                        isInvalid={!!errors.menor}
                                        disabled={ defensoriesLoading }
                                    >
                                        <option value="">Seleccione el Tipo</option>
                                        {
                                            types.map(type => (
                                                <option value={type.id} key={`dt${type.id}`}>
                                                    { type.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.menor }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="unidad">Unidad</label>
                                    <Form.Control
                                        as="select"
                                        id="unidad"
                                        className="form-control"  
                                        name="unidad" 
                                        type="text" 
                                        value={ values.unidad }
                                        onChange={ handleChange }
                                        isInvalid={!!errors.unidad}
                                        disabled={ defensoriesLoading }
                                    >
                                        <option value="">Seleccione la Unidad</option>
                                        {   Units.map(unit => (
                                                unit.activo===1 && (unit.perfil===5 || unit.perfil.id===5)
                                                ?
                                                    <option value={unit.id} key={`dt${unit.id}`}>
                                                        { unit.descripcion }
                                                    </option>
                                                :
                                                    null                                   
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.unidad }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <label htmlFor="responsable">Responsable</label>
                                    <Form.Control
                                        id="responsable"
                                        className="form-control" 
                                        autoFocus 
                                        name="responsable" 
                                        type="text" 
                                        value={ values.responsable }
                                        onChange={handleChange}
                                        isInvalid={!!errors.responsable}
                                        disabled={ defensoriesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.responsable }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-8">
                                    <label htmlFor="direccion">Dirección</label>
                                    <Form.Control
                                        id="direccion"
                                        className="form-control" 
                                        autoFocus 
                                        name="direccion" 
                                        type="text" 
                                        value={ values.direccion }
                                        onChange={handleChange}
                                        isInvalid={!!errors.direccion}
                                        disabled={ defensoriesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.direccion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="email">Email</label>
                                    <Form.Control
                                        id="email"
                                        className="form-control" 
                                        autoFocus 
                                        name="email" 
                                        type="text" 
                                        value={ values.email }
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                        disabled={ defensoriesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.email }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="telefono">Teléfono</label>
                                    <Form.Control
                                        id="telefono"
                                        className="form-control" 
                                        autoFocus 
                                        name="telefono" 
                                        type="text" 
                                        value={ values.telefono }
                                        onChange={handleChange}
                                        isInvalid={!!errors.telefono}
                                        disabled={ defensoriesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.telefono }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                defensoriesLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ defensoriesLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ defensoriesLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default DefensoryForm;
